import { skipToken, useSubscription } from '@apollo/client/react';
import { useState } from 'react';
import type { MESSAGES } from '@guuru/chat-common';
import TIMEOUT_STATUS from '../subscriptions/WaitTimeoutMessage';

interface WaitTimeout {
  text?: string | null;
  waitTimeoutStatus: keyof typeof MESSAGES;
}

export default (messageId: string | null, chatId: string, skip: boolean) => {
  const [waitTimeoutUpdate, setWaitTimeoutUpdate] =
    useState<WaitTimeout | null>();

  useSubscription(
    TIMEOUT_STATUS,
    messageId && !skip
      ? {
          variables: { id: chatId },
          onData: ({ data: { data } }) => {
            setWaitTimeoutUpdate({
              text: data?.waitTimeoutMessage?.text,
              waitTimeoutStatus:
                data?.waitTimeoutMessage?.metadata.waitTimeoutStatus,
            });
          },
        }
      : skipToken,
  );

  return waitTimeoutUpdate;
};
